// extracted by mini-css-extract-plugin
export var container = "p_b";
export var open = "p_bf";
export var section = "p_d";